module.exports = __webpack_public_path__ + "img/3-3.8eae79d7.png";